export default (to, from, next) => {
  let token = localStorage.getItem('auth_token');
  let routeInit = ['/', '/signup', '/signup2', '/signin'].includes(to.fullPath);
  if (routeInit) {
    if (token) {
      next('/equipments');
    } else {
      next();
    }
  } else
  if (token) {
    next();
  } else {
    next('/signin');
  }
};



// WEBPACK FOOTER //
// ./src/router/auth-guard.js